import { LineChart } from "@tremor/react";
import ChartCard from "../../../../shared/charts/ChartCard";

export default function AverageHourlyRateChart({ data, canSee, target }) {
  if (!canSee) return null;
  return (
    <ChartCard
      title="Average Hourly Rate"
      subtitle={`Blended rate across T&M engagements · Target ${target} kr/hr`}
    >
      <LineChart
        className="h-64"
        data={data}
        index="month"
        categories={["Actual", "Forecast", "Target"]}
        colors={["emerald", "slate", "amber"]}
        valueFormatter={(v) => `${Math.round(v)} kr/hr`}
        showAnimation={false}
        yAxisWidth={70}
      />
    </ChartCard>
  );
}
